module.exports = __webpack_public_path__ + "static/media/userIcon.8c845481.svg";